import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";


import PatientBilling from "../../HospitalPages/AccountandBilling/PatientBilling";
import OPDBill from "../../HospitalPages/AccountandBilling/OPDBill";
import IPDBill from "../../HospitalPages/AccountandBilling/IPDBill";
import AdvanceandRefunds from "../../HospitalPages/AccountandBilling/AdvanceandRefunds";
import InsuranceClaim from "../../HospitalPages/AccountandBilling/InsuranceClaim";
import DailyCollectionReport from "../../HospitalPages/AccountandBilling/DailyCollectionReport";
import RevenueReports from "../../HospitalPages/AccountandBilling/RevenueReports";
import DashboardCards from "../HospitalDashBoardCards";
import { decrypt } from "../../components/cryptoUtil";
import { includeCardForRoles, ROLES } from "../componenet/heading";

const AccountDashBoard = () => {

  const tokenData = localStorage.getItem("tokenData");
  const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  const userName = decryptedData.userfullname || "";

  
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const userRole = decryptedData.userrole || "";
const cardRoles = {
  "Patient Billing": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "OPD Bill": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "IPD Bill": [ROLES.RECEPTIONIST],
  "Advance & Refunds": [ROLES.STAFF],
  "Daily Collection Report": [ROLES.ACCOUNTSECTION],
  "Revenue Reports": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};

  const cards = [
    ...includeCardForRoles(cardRoles["Patient Billing"], userRole,{
      title: "Patient Billing",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <PatientBilling />,category: "👨‍⚕️Account & Billing Data Managament",
    }),
    ...includeCardForRoles(cardRoles["OPD Bill"], userRole,{
      title: "OPD Bill",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <OPDBill />,category: "👨‍⚕️Account & Billing Data Managament",
    }),
   
    ...includeCardForRoles(cardRoles["IPD Bill"], userRole,{
      title: "IPD Bill",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <IPDBill />,category: "👨‍⚕️Account & Billing Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Advance & Refunds"], userRole,{
      title: "Advance & Refunds",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <AdvanceandRefunds />,category: "👨‍⚕️Account & Billing Data Managament",
    }),

     ...includeCardForRoles(cardRoles["Daily Collection Report"], userRole,{
      title: "Daily Collection Report",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <DailyCollectionReport />,category: "👨‍⚕️Account & Billing Data Managament",
    }),

    ...includeCardForRoles(cardRoles["Revenue Reports"], userRole,{
      title: "Revenue Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <RevenueReports />,category: "👨‍⚕️Account & Billing Data Managament",
    }),

  ];


  // 
  

   return (
    <DashboardCards
      cards={cards}
      menulabel={1}
      welcomeMessage={
        <Typography variant="h5" align="center" gutterBottom>
         
          👨‍⚕️ Welcome {userName}
        </Typography>
      }
    />
  );
};

export default AccountDashBoard;
